export default __webpack_public_path__ + "static/media/Delivery.af78a8ae.svg";